// Angular Imports
import { inject } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router'
// Shared Imports
import { ECompany } from '@shared/models'
import { AuthStore } from '@shared/store'

export const hasCompaniesGuard: CanActivateFn = (
	route: ActivatedRouteSnapshot,
	_state: RouterStateSnapshot
) => {
	const authStore = inject(AuthStore)

	const checkUserCompanies = ({ companiesToVerify }: CheckUserCompanies): boolean => {
		// console.log('companiesToVerify', companiesToVerify)
		// We verify if the current company of the user is in the companies that are available for this route
		if (
			route.data &&
			route.data['companiesAllowed'] &&
			route.data['companiesAllowed'].some((copmany: ECompany) =>
				companiesToVerify.includes(copmany)
			)
		) {
			// console.error('[COMPANY] Company Permission Granted')
			return true
		} else {
			// console.error('[COMPANY] Company Permission Denied')
			return false
		}
	}

	return checkUserCompanies({ companiesToVerify: authStore.companies() })
}

interface CheckUserCompanies {
	companiesToVerify: ECompany[]
}
